module.exports = __webpack_public_path__ + "img/card6.f5c7b60f.jpg";